import React from 'react';
import { Upload, Button } from 'antd';
import { Upload as UploadIcon, X as CloseIcon } from 'lucide-react';
import styles from '../../pages/UpdatePersonalProfilePage.module.css';

interface UpdateHoroscopeSectionProps {
  horoscopePreview: string | null;
  horoscopeUploading: boolean;
  horoscopeSelectedCount: number;
  onClear: () => void;
  onBeforeUpload: (file: File) => boolean | Promise<boolean>;
}

export const UpdateHoroscopeSection: React.FC<UpdateHoroscopeSectionProps> = ({
  horoscopePreview,
  horoscopeUploading,
  horoscopeSelectedCount,
  onClear,
  onBeforeUpload,
}) => {
  return (
    <div className={styles.horoscopeSection}>
      {horoscopePreview && (
        <div className={styles.horoscopePreviewWrapper}>
          <div className={styles.horoscopePreviewInner}>
            <img
              src={horoscopePreview}
              alt="Lá số tử vi"
              className={styles.horoscopePreviewImage}
            />
            <button
              type="button"
              className={styles.horoscopeRemoveButton}
              onClick={onClear}
            >
              <CloseIcon size={18} />
            </button>
          </div>
        </div>
      )}

      <div className={styles.horoscopeUploadWrapper}>
        <Upload.Dragger
          multiple={false}
          showUploadList={false}
          accept="image/*"
          beforeUpload={onBeforeUpload}
          disabled={horoscopeUploading}
          className={styles.horoscopeDragger}
        >
          <div className={styles.horoscopeDraggerContent}>
            <UploadIcon size={32} className={styles.horoscopeUploadIcon} />
            <p className={styles.horoscopeDraggerTitle}>
              Kéo thả ảnh vào đây để tải lên hoặc
            </p>
            <Button type="primary" size="middle">
              Chọn ảnh
            </Button>
            <p className={styles.horoscopeDraggerHint}>
              Hỗ trợ các định dạng JPG, PNG, WebP. Dung lượng tối đa 5MB.
            </p>
          </div>
        </Upload.Dragger>
        <div className={styles.horoscopeCountText}>
          Đã chọn {horoscopeSelectedCount}/5 ảnh
        </div>
      </div>
    </div>
  );
};

